// ScrollToTopButton.jsx
import { useState, useEffect } from "react";

export default function ScrollToTopButton() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            setIsVisible(window.scrollY > 500);
        };

        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        isVisible && (
            <img
                src="https://img.perniaspopupshop.com/ppus-assets/icons/back-to-top.svg"
                alt="Scroll to top"
                onClick={scrollToTop}
                style={{
                    position: "fixed",
                    bottom: "40px",
                    right: "30px",
                    width: "50px",
                    height: "50px",
                    cursor: "pointer",
                    borderRadius: "50%",
                    boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                    zIndex: 9999,  // ✅ सबसे जरूरी लाइन
                }}
            />
        )
    );
}
